import { HttpPromise } from "@shared/svelte/Modules/ApiService";

export const updateDefaultDistributor = async function(productTypeId: number, defaultedDistributorId: number, successCallback, errorCallback) {
  await HttpPromise({
    method: "POST",
    url: "api/retailer/default_distributor",
    data: {
      product_type_id: productTypeId,
      distributor_id: defaultedDistributorId,
    }
  }).then(function success(_res) {
    successCallback(productTypeId, defaultedDistributorId);
  }, function error(res) {
    errorCallback(res);
  });
}
